//import Moment from "moment";

const getCount = (state) => {
	return state.mecanicos.length;
}

const ultimaAtualizacaoListaMecanico = (state) => {
	if (state.ultimaAtualizacaoListaMecanico == null) {
		return true;
	}
	else if(!state.mecanicos)
	{
		return true;
	}
	else {
		const d = new Date();
		let hour = d.getHours();
		return (
			state.mecanicos.length == 0 ||
			hour - state.ultimaAtualizacaoListaMecanico.getHours() > 0
		);
	}
}

export default {
	getCount,
	ultimaAtualizacaoListaMecanico
}